// Function needed to bypass IE11 'Invalid calling object' error
const redirect = (route)=>window && window.location.assign(route)
;

export { redirect };
//# sourceMappingURL=redirect.js.map
